import React from "react";

export default function ContextMenuComponent({
  contextMenu,
  setContextMenu,
  onClose = () => setContextMenu(null),
}) {
  if (!contextMenu) return null;

  return (
    <div
      onClick={onClose}
      onTouchStart={onClose}
      className="border-0 top-0 left-0 text-sm z-50 h-screen w-screen fixed"
    >
      <div
        onTouchStart={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        className="bg-black w-auto rounded-md absolute"
        style={contextMenu.style}
      >
        {typeof contextMenu.component === "function" ? (
          <contextMenu.component />
        ) : (
          contextMenu.component
        )}
      </div>
    </div>
  );
}
